'use client';

import { useEffect, useState } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

export function useResponsiveLayout() {
  const theme = useTheme();
  const [hasTouchInput, setHasTouchInput] = useState(false);

  // Check for touch capability
  useEffect(() => {
    const checkTouch = () => {
      setHasTouchInput(
        'ontouchstart' in window ||
          navigator.maxTouchPoints > 0 ||
          // @ts-ignore - for older browsers
          navigator.msMaxTouchPoints > 0
      );
    };

    checkTouch();
    // Re-check on resize in case of device rotation
    window.addEventListener('resize', checkTouch);
    return () => window.removeEventListener('resize', checkTouch);
  }, []);

  // Screen size breakpoints
  const isNarrowScreen = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isWideEnoughForSidebar = useMediaQuery('(min-width: 800px)'); // >= 800px

  // Layout decisions
  const appBarPosition: 'top' | 'bottom' = isNarrowScreen && hasTouchInput ? 'bottom' : 'top';
  const contextPanelVariant: 'sidebar' | 'toolbar' = isWideEnoughForSidebar ? 'sidebar' : 'toolbar';

  return {
    isNarrowScreen,
    isWideEnoughForSidebar,
    hasTouchInput,
    appBarPosition,
    contextPanelVariant,
  };
}
